import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name.split(" ")[0]}`);
      const dest = location.state?.from || (user.role === "admin" ? "/admin" : "/account");
      navigate(dest);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16" data-testid="login-page">
      <div className="text-center mb-8">
        <img src={LOGO_URL} alt="Aethel Decor — Beyond Decor. Simply Elevated." className="h-16 mx-auto" />
        <h1 className="mt-5 text-3xl text-primary font-medium">Welcome back</h1>
        <p className="mt-2 text-sm text-muted-foreground">Login to view your orders</p>
      </div>
      <form onSubmit={submit} className="space-y-5">
        <label className="block">
          <span className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary"
            data-testid="login-email"
            required
          />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary"
            data-testid="login-password"
            required
          />
        </label>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-primary text-primary-foreground py-4 text-sm tracking-wide flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="login-submit"
        >
          {loading && <Loader2 size={18} className="animate-spin" />} Login
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        New here?{" "}
        <Link to="/register" className="text-primary font-semibold link-underline" data-testid="to-register">
          Create an account
        </Link>
      </p>
    </div>
  );
}
